import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {IdName} from '@domain/id-name';
import {map, Observable} from 'rxjs';
import {Repository} from '../repository';

@Injectable({providedIn: 'root'})
export class HttpRejectReasonGroupsService implements Repository<IdName, IdName> {
  public constructor(
    private readonly httpClient: HttpClient,
    private readonly backendConfiguration: BackendConfiguration
  ) {}

  public getAll(): Observable<IdName[]> {
    return this.httpClient
      .get(`${this.backendConfiguration.getWorkerEndpoint()}reject-reason-group`)
      .pipe(map((rejectReasonGroupsJSON: any) => rejectReasonGroupsJSON.map((rejectReasonGroupJSON: any) => IdName.fromJSON(rejectReasonGroupJSON))));
  }

  public delete(id: string | number): Observable<void> {
    throw new Error('Method not implemented.');
  }

  public getById(id: number): Observable<IdName> {
    throw new Error('Method not implemented.');
  }

  public save(item: IdName): Observable<number> {
    throw new Error('Method not implemented.');
  }

  public update(item: IdName): Observable<void | number> {
    throw new Error('Method not implemented.');
  }
}
